import {
	TableName,
} from 'utils/database/enums/table-name.enum';

/**
 * ## Primary key
 * The first key in the string is always the PK
 * - If you want the PK to be auto-incremental use ++keyPath (has to be a numerical value)
 * - Using ++ without a key path, it will be a hidden incremented id.
 * - not defining the key will make the PK hidden(,nextKey,nextKey).
 *
 * ## Syntax for indexes
 * - any key included in the string is a indexed key.
 * - & in front of the key makes it a unique index
 * - * is for using an array as index
 * - [key1+key2] makes the index a compound index
 *
 * ## Warning
 * Do not index properties containing images, movies or large strings.
 * You can store them but not index them (as in leave them out of the index strings
 *
 * ## Remember!
 * You do not need to index every key in the object (you index them by adding them below)
 *
 * Reference: https://dexie.org/docs/Version/Version.stores()
 */
const VERSION_1 = {
	[TableName.ASSIGNMENTS]: '++id',
	[TableName.SETTINGS]: 'key',
	[TableName.SYNC_DATA]: '++id',
	[TableName.SYNC_NOTIFICATION]: '++id',
};
const VERSION_2 = {
	[TableName.ASSIGNMENTS]: '++id',
	[TableName.SETTINGS]: 'key',
	[TableName.API_QUEUE]: 'timestamp',
	[TableName.SYNC_DATA]: '++id',
	[TableName.SYNC_NOTIFICATION]: '++id',
};
const VERSION_3 = {
	[TableName.ASSIGNMENTS]: '++id, date, status',
	[TableName.SETTINGS]: 'key',
	[TableName.API_QUEUE]: 'timestamp',
	[TableName.SYNC_DATA]: '++id',
	[TableName.SYNC_NOTIFICATION]: '++id',
};
const VERSION_4 = {
	[TableName.ASSIGNMENTS]: '++id, date, status',
	[TableName.SETTINGS]: 'key',
	[TableName.API_QUEUE]: 'timestamp',
	[TableName.SYNC_DATA]: '++id',
	[TableName.SYNC_NOTIFICATION]: '++id',
};
const VERSION_5 = {
	[TableName.DEVIATIONS]: '++id, assignmentId',
	[TableName.ASSIGNMENTS]: '++id, date, status',
	[TableName.SETTINGS]: 'key',
	[TableName.API_QUEUE]: 'timestamp',
	[TableName.SYNC_DATA]: '++id',
	[TableName.SYNC_NOTIFICATION]: '++id',
};
const VERSION_6 = {
	[TableName.DEVIATIONS]: '++id, assignmentId, type',
	[TableName.ASSIGNMENTS]: '++id, date, status',
	[TableName.SETTINGS]: 'key',
	[TableName.API_QUEUE]: 'timestamp',
	[TableName.SYNC_DATA]: '++id',
	[TableName.SYNC_NOTIFICATION]: '++id',
};
const VERSION_7 = {
	[TableName.DEVIATIONS]: '++id, transportId, code',
	[TableName.ASSIGNMENTS]: '++id, date, status',
	[TableName.SETTINGS]: 'key',
	[TableName.API_QUEUE]: 'timestamp',
	[TableName.SYNC_DATA]: '++id',
	[TableName.SYNC_NOTIFICATION]: '++id',
};
const VERSION_8 = {
	[TableName.DEVIATIONS]: '++id, transportId, code',
	[TableName.ASSIGNMENTS]: '++id, date, status',
	[TableName.ROUTES]: '++id',
	[TableName.SETTINGS]: 'key',
	[TableName.API_QUEUE]: 'timestamp',
	[TableName.SYNC_DATA]: '++id',
	[TableName.SYNC_NOTIFICATION]: '++id',
};
const VERSION_9 = {
	[TableName.DEVIATIONS]: '++id, transportId, code',
	[TableName.ASSIGNMENTS]: '++id, date, status',
	[TableName.ROUTES]: '++id',
	[TableName.SETTINGS]: 'key',
	[TableName.API_QUEUE]: 'timestamp',
	[TableName.SYNC_DATA]: '++id',
	[TableName.SYNC_NOTIFICATION]: '++id',
	[TableName.OPEN_GATE_COUNTER]: '[gln+container+date], counter',
};

const VERSION_10 = {
	[TableName.DEVIATIONS]: '++id, transportId, code',
	[TableName.ASSIGNMENTS]: '++id, date, status',
	[TableName.ROUTES]: '++id',
	[TableName.SETTINGS]: 'key',
	[TableName.API_QUEUE]: 'timestamp',
	[TableName.SYNC_DATA]: '++id',
	[TableName.SYNC_NOTIFICATION]: '++id',
	[TableName.OPEN_GATE_COUNTER]: '[gln+container+date], counter',
	[TableName.FEEDBACK]: 'id',
};


const VERSION_11 = {
	[TableName.DEVIATIONS]: '++id, transportId, code',
	[TableName.ASSIGNMENTS]: '++id, date, status',
	[TableName.SETTINGS]: 'key',
	[TableName.API_QUEUE]: 'timestamp',
	[TableName.SYNC_DATA]: '++id',
	[TableName.SYNC_NOTIFICATION]: '++id',
	[TableName.OPEN_GATE_COUNTER]: '[gln+container+date], counter',
	[TableName.FEEDBACK]: 'id',
};

/**
 * A ordered list of the schema versions from oldest to newest.
 */
export const takeCargoStoresSchemas = [
	VERSION_1,
	VERSION_2,
	VERSION_3,
	VERSION_4,
	VERSION_5,
	VERSION_6,
	VERSION_7,
	VERSION_8,
	VERSION_9,
	VERSION_10,
	VERSION_11,
];